import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useScrollAwareTooltip } from '../../../../hooks/useScrollAwareTooltip';
import type { InitiativeOption } from '../../../../store/process-analysis-store/process-analysis-store.type';
import { baseBlack, skyDark } from '../../../../styles/design-tokens';
import { Checkbox } from '../../../../ui-library/checkbox/checkbox';
import { Tooltip } from '../../../../ui-library/tooltip/tooltip';
import { Text } from '../../../../ui-library/typography/typography';
import { MAX_SELECTED_INITIATIVES } from './initiative-list.constants';

type Props = {
  initiative: InitiativeOption;
  isSelected: boolean;
  isSelectedTrends: boolean;
  isDisabled: boolean;
  onToggleSelection: () => void;
  onToggleTrend: () => void;
};

export const InitiativeItem = ({
  initiative,
  isSelected,
  isSelectedTrends,
  isDisabled,
  onToggleSelection,
  onToggleTrend,
}: Props) => {
  const i18n = useTranslation();
  const forceCloseTooltip = useScrollAwareTooltip();

  const handleTrendToggle = () => {
    if (isSelected) {
      onToggleTrend();
    }
  };

  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap">
      <Group gap="sm" wrap="nowrap" align="flex-start" style={{ flex: 1 }}>
        <Tooltip
          label={i18n.t('common.tooltips.max_selection_limit', {
            count: MAX_SELECTED_INITIATIVES,
          })}
          variant="white"
          disabled={!isDisabled || forceCloseTooltip}
        >
          <Checkbox checked={isSelected} onChange={onToggleSelection} disabled={isDisabled} size="sm" />
        </Tooltip>
        <Text
          size="small"
          color={isDisabled ? skyDark : baseBlack}
          style={{
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            flex: 1,
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            minWidth: 0,
          }}
          role="button"
          tabIndex={isDisabled ? -1 : 0}
          aria-disabled={isDisabled}
          onClick={() => {
            if (!isDisabled) {
              onToggleSelection();
            }
          }}
        >
          {initiative.name}
        </Text>
      </Group>
      {isSelected && <Checkbox checked={isSelectedTrends} onChange={handleTrendToggle} size="sm" />}
    </Group>
  );
};
